import React, { useState } from 'react';

type Props = {
  value: number | '';
  min: number;
  max?: number;
  step?: number | 'any';
  onChange: (value: number) => void;
  style?: React.CSSProperties;
};

export function QrSizeInput({ value, min, max, step = 1, onChange, style }: Props) {
  const [draft, setDraft] = useState<string | null>(null);
  const commit = (text: string) => {
    if (text.trim() && Number.isFinite(Number(text))) {
      const number = step === 'any' ? Number(text) : Math.round(Number(text));
      onChange(Math.min(max ?? Infinity, Math.max(min, number)));
    }
    setDraft(null);
  };

  return <input
    type="number"
    min={min}
    max={max}
    step={step}
    value={draft ?? value}
    onChange={event => {
      const text = event.target.value;
      setDraft(text);
      // Valid complete values can update the preview immediately. An incomplete
      // or undersized draft must not rewrite the user's next keystroke.
      const number = Number(text);
      if (text.trim() && Number.isFinite(number) && (step === 'any' || Number.isInteger(number))
        && number >= min && number <= (max ?? Infinity)) onChange(number);
    }}
    onBlur={event => commit(event.currentTarget.value)}
    onKeyDown={event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.currentTarget.blur();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.currentTarget.value = String(value);
        setDraft(null);
        event.currentTarget.blur();
      }
    }}
    style={style}
  />;
}
